/** @jsxImportSource @emotion/react */
import React from "react";
import {
  FooterRoot,
  FooterInner,
  Links,
  FooterLink,
  FooterExternalLink,
  LangSwitch,
  FlagButton,
} from "./style";

export const Footer: React.FC = () => {
  return (
    <FooterRoot>
      <FooterInner>
        <Links>
          <FooterExternalLink
            href="https://www.instagram.com/vip___resale/"
            target="_blank"
            rel="noreferrer"
          >
            INSTAGRAM
          </FooterExternalLink>
          <FooterExternalLink
            href="https://t.me/+38CPsFCKw3NmMTQ6"
            target="_blank"
            rel="noreferrer"
          >
            TELEGRAM
          </FooterExternalLink>
          <FooterLink to="/about">ПРО НАС</FooterLink>
          <FooterLink to="/payment">ОПЛАТА І ДОСТАВКА</FooterLink>
          {/* <FooterLink to="/returns">ПОВЕРНЕННЯ ТА ОБМІН</FooterLink> */}
          {/* <FooterLink to="/contacts">КОНТАКТИ</FooterLink> */}
        </Links>

        <LangSwitch>
          <FlagButton aria-label="Ukrainian">🇺🇦</FlagButton>
          <FlagButton aria-label="English">🇬🇧</FlagButton>
        </LangSwitch>
      </FooterInner>
    </FooterRoot>
  );
};
